module.exports = __webpack_public_path__ + "img/Differentiation-BRME_GSE179572.407cfca8.png";